export default class DeliveryMethodDomainService {
    static get SMS() {
        return 1;
    }
    static get EMAIL() {
        return 2;
    }
    static get EMAIL_NOTIFICATION() {
        return 3;
    }
    static get APPLICATION() {
        return 4;
    }
    // @deprecated - Do not use it
    static get EXTERNAL() {
        return 5;
    }
}
